<template>
  <div class="page-container">
    <main :class="['main-content', { nested: isMemberCenterContext }]">
      <div class="page-inner-box">

        <div class="my-coupons-container">
          <!-- 主内容区 -->
          <div class="content-main">

            
            <!-- 我的优惠券 -->
            <div class="coupons-section">
              <!-- 优惠券状态标签页 -->
              <div class="coupon-tabs">
                <div class="tab-item" :class="{ active: activeTab === 'unused' }" @click="activeTab = 'unused'">未使用</div>
                <div class="tab-item" :class="{ active: activeTab === 'used' }" @click="activeTab = 'used'">已使用</div>
                <div class="tab-item" :class="{ active: activeTab === 'expired' }" @click="activeTab = 'expired'">已过期</div>
                <div class="tab-item receive-tab" :class="{ active: receiveMode }" @click="enterReceiveMode">领取优惠券</div>
              </div>
              
              <div class="divider"></div>

              <!-- 优惠券列表 -->
              <div v-if="isLoggedIn" class="coupons-list">
                <!-- 未使用优惠券 -->
                <div v-if="activeTab === 'unused'" class="coupon-grid">
                  <div v-for="coupon in unusedCoupons" :key="coupon.id" class="coupon-card-bg">
                    <div class="coupon-left">
                      <div class="coupon-price">
                        <span v-if="coupon.amountPrefix" class="currency">{{ coupon.amountPrefix }}</span>
                        <span class="amount">{{ coupon.amountText }}</span>
                      </div>
                      <div class="coupon-tag">{{ coupon.tagText }}</div>
                    </div>
                    
                    <div class="coupon-middle">
                      <div class="coupon-name">{{ coupon.nameText }}</div>
                      <div v-if="coupon.limitText" class="coupon-limit">{{ coupon.limitText }}</div>
                      <div class="coupon-time">有效时间：{{ coupon.timeText }}</div>
                    </div>
                    
                    <div class="coupon-right">
                      <div class="use-btn" @click="useCoupon(coupon.id)">可使用</div>
                    </div>
                  </div>
                  
                  <!-- 无未使用优惠券提示 -->
                  <div v-if="unusedCoupons.length === 0" class="no-coupons">
                    <el-empty description="暂无未使用优惠券" />
                  </div>
                </div>
                
                <!-- 已使用优惠券 -->
                <div v-if="activeTab === 'used'" class="coupon-grid">
                  <div v-for="coupon in usedCoupons" :key="coupon.id" class="coupon-card-bg used">
                    <div class="coupon-left">
                      <div class="coupon-price">
                        <span v-if="coupon.amountPrefix" class="currency">{{ coupon.amountPrefix }}</span>
                        <span class="amount">{{ coupon.amountText }}</span>
                      </div>
                      <div class="coupon-tag">{{ coupon.tagText }}</div>
                    </div>
                    
                    <div class="coupon-middle">
                      <div class="coupon-name">{{ coupon.nameText }}</div>
                      <div v-if="coupon.limitText" class="coupon-limit">{{ coupon.limitText }}</div>
                      <div class="coupon-time">有效时间：{{ coupon.timeText }}</div>
                    </div>
                    
                    <div class="coupon-right">
                      <div class="use-btn disabled">已使用</div>
                    </div>
                  </div>
                  
                  <!-- 无已使用优惠券提示 -->
                  <div v-if="usedCoupons.length === 0" class="no-coupons">
                    <el-empty description="暂无已使用优惠券" />
                  </div>
                </div>

                <!-- 已过期优惠券 -->
                <div v-if="activeTab === 'expired'" class="coupon-grid">
                  <div v-for="coupon in expiredCoupons" :key="coupon.id" class="coupon-card-bg used">
                    <div class="coupon-left">
                      <div class="coupon-price">
                        <span v-if="coupon.amountPrefix" class="currency">{{ coupon.amountPrefix }}</span>
                        <span class="amount">{{ coupon.amountText }}</span>
                      </div>
                      <div class="coupon-tag">{{ coupon.tagText }}</div>
                    </div>
                    
                    <div class="coupon-middle">
                      <div class="coupon-name">{{ coupon.nameText }}</div>
                      <div v-if="coupon.limitText" class="coupon-limit">{{ coupon.limitText }}</div>
                      <div class="coupon-time">有效时间：{{ coupon.timeText }}</div>
                    </div>
                    
                    <div class="coupon-right">
                      <div class="use-btn disabled">已过期</div>
                    </div>
                  </div>
                  
                  <!-- 无已过期优惠券提示 -->
                  <div v-if="expiredCoupons.length === 0" class="no-coupons">
                    <el-empty description="暂无已过期优惠券" />
                  </div>
                </div>
              </div>
              <div v-else class="coupons-list">
                <div class="no-coupons">
                  <el-empty description="登录后查看优惠券">
                    <el-button type="primary" size="small" @click="openLogin">去登录</el-button>
                  </el-empty>
                </div>
              </div>
            </div>

            <!-- 领取优惠券 -->
            <div v-if="receiveMode" class="coupons-section">
              <div class="coupon-grid">
                <div v-for="coupon in availableCoupons" :key="coupon.id" :class="['coupon-card-bg', { received: coupon.claimed }]">
                  <div class="coupon-left">
                    <div class="coupon-price">
                      <span class="currency">¥</span>
                      <span class="amount">{{ coupon.amount }}</span>
                    </div>
                    <div class="coupon-tag">{{ coupon.tag }}</div>
                  </div>
                  
                  <div class="coupon-middle">
                    <div class="coupon-name">{{ coupon.name }}</div>
                    <div class="coupon-limit">{{ coupon.limitText }}</div>
                    <div class="coupon-time">有效时间：{{ coupon.timeText }}</div>
                  </div>
                  
                  <div class="coupon-right">
                    <div 
                      :class="['use-btn', { disabled: coupon.claimed }]" 
                      @click="claimCoupon(coupon)"
                    >
                      {{ coupon.claimed ? '已领取' : '立即领取' }}
                    </div>
                  </div>
                </div>
                
                <div v-if="availableCoupons.length === 0" class="no-coupons">
                  <el-empty description="暂无可领取的优惠券" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

  </div>
</template>

<script>
import { getMyCoupons, getAvailableCoupons, claimCoupon as claimCouponApi } from '@/api/authApi'
import { mapGetters } from 'vuex'

export default {
  name: 'MyCoupons',
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    isMemberCenterContext() {
      return this.$route.path.startsWith('/member-center')
    },
    unusedCoupons() {
      return this.coupons.filter(coupon => Number(coupon.status) === 0)
    },
    usedCoupons() {
      return this.coupons.filter(coupon => Number(coupon.status) === 1)
    },
    expiredCoupons() {
      return this.coupons.filter(coupon => Number(coupon.status) === 2)
    }
  },
  watch: {
    activeTab() {
      if (this.activeTab) {
        this.receiveMode = false
        this.loadCoupons()
      }
    },
    isLoggedIn(next) {
      if (!next) {
        this.coupons = []
        return
      }
      this.loadCoupons()
    }
  },
  created() {
    this.loadCoupons()
  },
  mounted() {
    if (typeof window !== 'undefined') {
      this._onLoginSuccess = () => this.loadCoupons()
      window.addEventListener('auth:login-success', this._onLoginSuccess)
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined' && this._onLoginSuccess) {
      window.removeEventListener('auth:login-success', this._onLoginSuccess)
      this._onLoginSuccess = null
    }
  },
  data() {
    return {
      activeTab: 'unused',
      // 优惠券数据
      coupons: [],
      // 领取模式
      receiveMode: false,
      availableCoupons: []
    }
  },
  methods: {
    formatNumber(val) {
      const n = Number(val)
      if (!Number.isFinite(n)) return String(val == null ? '' : val)
      return n
        .toFixed(2)
        .replace(/\.00$/, '')
        .replace(/(\.\d)0$/, '$1')
    },
    formatRateToZhe(val) {
      const n = Number(val)
      if (!Number.isFinite(n)) return ''
      if (n > 1 && n <= 10) return `${this.formatNumber(n)}折`
      if (n > 0 && n <= 1) return `${this.formatNumber(n * 10)}折`
      return `${this.formatNumber(n)}折`
    },
    normalizeCoupon(coupon, index) {
      const id = (coupon && (coupon.id ?? coupon.couponId ?? coupon.coupon_id)) ?? index

      const couponNameRaw = coupon && (coupon.couponName ?? coupon.templateName ?? coupon.name ?? coupon.title)
      const nameText = String(couponNameRaw || '优惠券')

      const couponTypeRaw = coupon && (coupon.couponType ?? coupon.type)
      const couponType = couponTypeRaw == null ? null : Number(couponTypeRaw)

      const discountAmountRaw = coupon && (coupon.discountAmount ?? coupon.amount ?? coupon.couponAmount ?? coupon.value ?? coupon.discount)
      const discountRateRaw = coupon && (coupon.discountRate ?? coupon.rate ?? coupon.discountPercent)
      const minAmountRaw = coupon && (coupon.minAmount ?? coupon.minSpend ?? coupon.thresholdAmount ?? coupon.useLimitAmount ?? coupon.limitAmount)
      const maxDiscountAmountRaw = coupon && (coupon.maxDiscountAmount ?? coupon.maxAmount ?? coupon.maxDiscount)

      const startTime =
        coupon && (coupon.startTime ?? coupon.beginTime ?? coupon.validStartTime ?? coupon.validFrom ?? coupon.getTime)
      const endTime = coupon && (coupon.endTime ?? coupon.expireTime ?? coupon.validEndTime ?? coupon.validTo)
      const expiryDateRaw = coupon && (coupon.expiryDate ?? coupon.validDateRange ?? coupon.validRange)
      const timeText =
        String(
          expiryDateRaw ||
            (startTime && endTime ? `${String(startTime)} - ${String(endTime)}` : startTime || endTime || '')
        )

      const statusRaw = coupon && (coupon.status ?? coupon.useStatus ?? coupon.couponStatus ?? coupon.state)
      const status = statusRaw == null ? 0 : Number(statusRaw)

      let amountPrefix = '¥'
      let amountText = this.formatNumber(discountAmountRaw)
      let tagText = '通用券'

      if (couponType === 2 && discountRateRaw != null) {
        amountPrefix = ''
        amountText = this.formatRateToZhe(discountRateRaw)
        tagText = '折扣券'
      } else if (couponType === 1) {
        tagText = '满减券'
      }

      let limitText = ''
      if (minAmountRaw != null && String(minAmountRaw) !== '') {
        limitText = `满${this.formatNumber(minAmountRaw)}可用`
      } else {
        limitText = '无门槛'
      }
      if (maxDiscountAmountRaw != null && String(maxDiscountAmountRaw) !== '') {
        limitText = `${limitText}，最高减${this.formatNumber(maxDiscountAmountRaw)}`
      }

      return {
        id,
        status,
        nameText,
        tagText,
        amountPrefix,
        amountText,
        limitText,
        timeText
      }
    },
    extractList(data) {
      if (Array.isArray(data)) return data
      if (!data) return []
      if (Array.isArray(data.list)) return data.list
      if (Array.isArray(data.records)) return data.records
      if (Array.isArray(data.items)) return data.items
      return []
    },
    async loadCoupons() {
      if (!this.isLoggedIn) {
        this.coupons = []
        return
      }
      try {
        const statusMap = {
          unused: 0,
          used: 1,
          expired: 2
        }
        const status = statusMap[this.activeTab]
        const res = await getMyCoupons({ status })
        const list = this.extractList(res && res.data)
        
        const now = new Date().getTime()
        const filteredList = list.filter(item => {
          if (this.activeTab === 'unused') {
            const expireTime = item && item.expireTime
            if (!expireTime) return true
            const expireDate = new Date(expireTime).getTime()
            return expireDate > now
          }
          return true
        })
        
        this.coupons = filteredList.map((item, index) => this.normalizeCoupon(item, index))
      } catch (err) {
        this.coupons = []
        this.$message.error((err && err.message) || '优惠券加载失败')
      }
    },
    openLogin() {
      if (typeof window === 'undefined') return
      const redirect = (this.$route && this.$route.fullPath) || window.location.pathname + window.location.search
      window.dispatchEvent(new CustomEvent('auth:login-required', { detail: { redirect } }))
    },
    useCoupon(couponId) {
      this.$router.push({
        name: 'study',
        query: { couponId: couponId == null ? '' : String(couponId) }
      })
    },
    enterReceiveMode() {
      this.receiveMode = true
      this.activeTab = null
      this.loadAvailableCoupons()
    },
    async loadAvailableCoupons() {
      try {
        const res = await getAvailableCoupons()
        const data = res && res.data
        if (Array.isArray(data)) {
          this.availableCoupons = data.map(c => ({
            id: c.id,
            amount: this.formatNumber(c.discountAmount),
            limitText: c.minAmount ? `满${this.formatNumber(c.minAmount)}元可用` : '无门槛',
            name: c.couponName || '优惠券',
            tag: c.couponType === 1 ? '满减券' : c.couponType === 2 ? '折扣券' : '商品券',
            timeText: `${String(c.validStartTime || '').slice(0, 10)} 至 ${String(c.validEndTime || '').slice(0, 10)}`,
            claimed: c.claimed || false
          }))
        }
      } catch (err) {
        this.$message.error('获取优惠券列表失败')
      }
    },
    async claimCoupon(coupon) {
      if (!coupon || coupon.claimed) return
      if (!this.isLoggedIn) {
        this.openLogin()
        return
      }
      try {
        await claimCouponApi(coupon.id)
        coupon.claimed = true
        this.$message.success('领取成功')
      } catch (err) {
        this.$message.error(err.message || '领取失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page-container { min-height: 100vh; display: flex; flex-direction: column; }
.main-content { flex: 1; padding-top: 20px; }
.main-content.nested { margin-top: 0; }
.main-content.nested .page-inner-box { width: 100%; margin: 0; }

.my-coupons-container {
  display: flex;
  gap: 24px;
}

/* 主内容区样式 */
.content-main {
  flex: 1;
}

.coupons-section {
  background: #fff;
}

/* 优惠券标签页 */
.coupon-tabs {
  display: flex;
  margin-bottom: 10px;
}

.tab-item {
  font-size: 16px;
  color: #666;
  margin-right: 30px;
  cursor: pointer;
  padding-bottom: 10px;
  
  &.active {
    color: #3E2CCD;
    font-weight: 600;
  }
}

.divider {
  height: 1px;
  background-color: #eee;
  margin-bottom: 30px;
  width: 100%;
}

/* 优惠券列表 */
.coupon-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

/* 优惠券卡片 - 使用背景图 */
.coupon-card-bg {
  width: 380px;
  height: 110px;
  background-image: url('~@/assets/image/bg_section.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  position: relative;
  
  &.used {
    filter: grayscale(100%);
    opacity: 0.7;
  }
}

.coupon-left {
  width: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
}

.coupon-price {
  color: #FF4433;
  font-weight: bold;
  display: flex;
  align-items: baseline;
  
  .currency {
    font-size: 16px;
  }
  
  .amount {
    font-size: 36px;
    line-height: 1;
  }
}

.coupon-tag {
  background-color: #FF6B5C;
  color: #fff;
  font-size: 12px;
  padding: 1px 6px;
  border-radius: 4px;
  margin-top: 5px;
}

.coupon-middle {
  flex: 1;
  padding-left: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.coupon-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
}

.coupon-limit {
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
}

.coupon-time {
  font-size: 12px;
  color: #999;
  transform: scale(0.9);
  transform-origin: left;
}

.coupon-right {
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.use-btn {
  background: #fff;
  color: #FF4433;
  border: 1px solid #FF4433;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  
  &.disabled {
    border-color: #999;
    color: #999;
    cursor: not-allowed;
  }
}

/* 无优惠券提示 */
.no-coupons {
  text-align: center;
  padding: 50px 0;
  width: 100%;
}
</style>
